export default __webpack_public_path__ + "static/media/logo-wh.9970e266.svg";